<!--
Created on 2021-04-10
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-10
-->
<template>
  <div id="menu-warning" class="menu menu-box-modal rounded-m" 
      data-menu-height="310"
      data-menu-width="310">
    <h1 class="text-center mt-3 pt-1"><i class="fa fa-3x fa-exclamation color-yellow-dark"></i></h1>
    <h1 class="text-center mt-3 font-700">{{ title }}</h1>
    <p v-if="message" id="error_text" class="boxed-text-l">
      {{ message }}
    </p>
    <p v-if="htmlMessage" class="boxed-text-l" v-html="htmlMessage"></p>
    <a href="#" class="close-menu btn btn-m btn-center-m button-s shadow-l rounded-s text-uppercase font-900 bg-yellow-dark">OK</a>
  </div>
</template>

<script>
export default {
  name: 'WarningModal',
  props: {
    title: String,
    message: String,
    htmlMessage: String,
  },
}
</script>

<style>

</style>